<template>
  <div class="activity-detail">
    <header>

    </header>
    <section>
      <div class="top-img">
        <img :src=goodsMsg.thumbnil alt="" class="t-img">
        <p class="back">
          <img src="../../assets/images/activity-img/activity-detail-img/icon-24-fanhui.png" alt="" @click="$router.replace('/')">
        </p>
      </div>

      <!-- 活动介绍 -->
      <div class="activity-introduce">
        <!-- 活动标题 -->
        <p class="activity-title">
          {{goodsMsg.name}}
          <span v-for="(item,index,) in goodsMsg.lable" :key="index" :class="tagStyle(index)">
            {{item}}
          </span>
          <img src="../../assets/images/activity-img/activity-detail-img/fenxiang.png" alt="" @click="shareBtn">
        </p>
        <!-- 活动详情 -->
        <div class="activity-msg">
          {{goodsMsg.desc}}
        </div>
      </div>
      <!-- 开通会员卡 -->
      <div class="open-card" @click="CardDetailsBtn" v-if="is_member">
        <p>
          开通会员享受 <span>{{goodsMsg.discount}}元/人</span>
        </p>
        <p>
          立即开通
        </p>
      </div>
      <div class="activity-recommend">
        <p class="title">
          图文介绍
        </p>
        <p class="content" v-html="goodsMsg.detail">
          <img src="../../assets/images/activity-img/activity-detail-img/img1.png" alt="">
        </p>
      </div>
    </section>
    <footer>
      <p>
        <span>￥</span>
        <span v-if="goodsMsg.ismember == 0">{{goodsMsg.price}}</span>
        <span v-else-if="goodsMsg.ismember == 1 && goodsMsg.isdiscount == 1">{{goodsMsg.discount}}</span>
        <span v-else-if="goodsMsg.ismember == 1 && goodsMsg.isdiscount == 0">{{goodsMsg.price}}</span>
        <span>/人</span>
        <span v-if="!is_member">原价：<del>{{goodsMsg.price}}</del></span>
      </p>
      <p @click="pay_btn">
        立即购买
      </p>
    </footer>
  </div>
</template>
<script>

import wx from 'weixin-js-sdk'
import Vue from 'vue';
import { Toast, Dialog} from 'vant';

Vue.use(Toast)

export default {
  data(){
    return{
      goodsId: '', // 商品id
      goodsMsg: [], // 商品详情
      url:'' , // 当前路由路径
      is_member: true , // 是否是会员 
    }
  },
  created(){
    // 登录 / 分享登录
    let uid = JSON.parse(localStorage.getItem("uid"));
    if(!uid){
      let wxcode = this.$route.query.code
      // 获取code
      if(!wxcode){
        //appid 可以从后端传过来 也可以写死 
        let APPID = this.domain.APPID
        // 跳转回调redirect_uri 可以从后端传过来 也可以写死 但是url必须是公网可访问的
        let REDIRECT_URI = encodeURIComponent(window.location.href)
        // 返回类型
        let code = 'code';
        // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
        let SCOPE = 'snsapi_userinfo';
        let STATE = '123';//随便写
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + REDIRECT_URI + '&response_type=' + code + '&scope=' + SCOPE + '&state=' + STATE + '#wechat_redirect';
        window.location.href = url;
        // console.log(url)
        // console.log(encodeURIComponent(this.domain.local_url))
      }else{
        // 传code
        window.localStorage.removeItem('uid');
        let mypid = this.$route.query.pid
        if(!mypid){
          mypid = 0
        }
        this.$axios.get(this.domain.url+"/api/user/public/login",{
        params:{
          pid : mypid,
          code : wxcode,
          url : this.domain.local_url
        },
        }).then((res) => {
          // console.log(res.data.data.uid)
          window.localStorage.setItem('uid',JSON.stringify(res.data.data.uid));
        })
      }
    }else{
      this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) => {
        // console.log(res)
        if(res.data.code == 0){
          window.localStorage.removeItem('uid');
          this.$router.go(0)
        }
      })
    }

    // 当前路由路径 分享 用
    this.url = window.location.href
    // 当前路径参数
    this.goodsId = this.$route.query.id
    // 商品详情
    this.$axios.get(this.domain.url+'/api/goods/index/detail?id='+this.goodsId).then((res) => {
      // console.log(res.data.data)
      this.goodsMsg = res.data.data
      // 会员判断
      if(this.goodsMsg.ismember == 1){
        this.is_member = false
      }
    })
    // console.log(this.goodsMsg)
  },
  mounted(){
    // 调用微信自带分享
    let usrId = JSON.parse(localStorage.getItem("uid"));
    let url = window.Location.href
      // console.log(this.goodsMsg)
    this.ShareImpl({
      shareTitle: this.goodsMsg.name,
      shareDesc: this.goodsMsg.desc,
      shareUrl: url + '&pid' +usrId,
      shareImg: this.goodsMsg.thumbnil,
    });
  },
  methods:{
    // 自带分享
    wxshare(){

    },
    // 标签样式
    tagStyle(index){
      return "person_" + index
    },
    // 分享
    shareBtn(){
      let usrId = JSON.parse(localStorage.getItem("uid"));
      let share_url = window.location.href
      window.location.href = "http://api.kfm666666.net/api/pay/index/wxshare?title=" + this.goodsMsg.name + '&desc=' + this.goodsMsg.desc + '&imgurl=' + this.goodsMsg.thumbnil + '&link=' + share_url + '&pid=' + usrId
      // let jump_url = "http://api.kfm666666.net/api/pay/index/wxshare?title=" + this.goodsMsg.name + '&desc=' + this.goodsMsg.desc + '&imgurl=' + this.goodsMsg.thumbnil + '&link=' + share_url + '&pid=' + usrId
      // http://api.kfm666666.net/api/pay/index/wxshare?title=标题&desc=摘要&imgurl=图片地址&link=网站链接

    },
    // 购买会员卡
    CardDetailsBtn(){
      console.log()
      this.$router.push({
        path:'/card-ecommend',
        query:{
          id : 1
        }
      })
    },
    // 支付
    pay_btn(){
      this.$axios.get(this.domain.url+"/api/user/public/integrality").then((res) => {
        // console.log(res)
        if(res.data.code == 1){
          let pay_url = "http://members.kfm666666.net/api/pay/index/wxpay/?type=" + "2" + "&gid=" + this.goodsId
          // console.log(pay_url)
          window.location.replace(pay_url)
        }else{
          Dialog.confirm({
            title: '请完善信息后再购买',
            // message: '弹窗内容'
          }).then(() => {
            this.$router.push('/perfect')
          }).catch(() => {
            // on cancel
          });
        }
      })
    },
    
    // 微信自带分享
    ShareImpl(option) {
      //option是分享的配置内容*/
      let aaa = window.location.href
      // window.console.log(url, JSON.stringify(option));
      let usrId = JSON.parse(localStorage.getItem("uid"));
      this.$axios.get('http://members.kfm666666.net/api/share/index/wxshare?link=http://members.kfm666666.net/').then((response) => {
        console.log(response)
          wx.config({
              debug: false,
              appId: response.data.data.shareConfig.appId,
              timestamp: response.data.data.shareConfig.timestamp,
              nonceStr: response.data.data.shareConfig.nonceStr,
              signature: response.data.data.shareConfig.signature,
              jsApiList: [
                // 'updateAppMessageShareData',
                // 'updateTimelineShareData',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
              ]
          });
          // console.log(Number(response.data.data.shareConfig.timestamp))
      }).catch(error => {
          window.console.log(error);
      });
      wx.ready(function () {
        // wx.updateAppMessageShareData({
        //     title: option.shareTitle,
        //     desc: option.shareDesc,
        //     link: option.shareUrl,
        //     imgUrl: option.shareImg,
        //     success:function(res){
        //       console.location(res)
        //     }
        // });
        // wx.updateTimelineShareData({
        //     title: option.shareTitle,
        //     desc: option.shareDesc,
        //     link: option.shareUrl,
        //     imgUrl: option.shareImg,
        //     success:function(res){
        //       console.location(res)
        //     }
        // });
        wx.onMenuShareTimeline({
            title: option.shareTitle,
            desc: option.shareDesc,
            link: option.shareUrl,
            imgUrl: option.shareImg,
            success:function(res){
              console.location(res)
            }
        });
        wx.onMenuShareAppMessage({
            title: option.shareTitle,
            desc: option.shareDesc,
            link: option.shareUrl,
            imgUrl: option.shareImg,
            success:function(res){
              console.location(res)
            }
        });
      })
      /*}*/
    }
  }
}
</script>
<style lang="less" scoped>
  .activity-detail{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // header{
    //   width: 100%;
    //   height: 3.6rem;

    // }
    section{
      width: 100%;
      flex: 1;
      z-index: 2;
      background: #F0F0F0;
      overflow: scroll;
      // 背景图
      .top-img{
        width: 100%;
        height: 3.6rem;
        position: relative;
        .t-img{
          width: 100%;
          height: 3.6rem;
        }
        .back{
          width: 100%;
          img{
            position: absolute;          
            width: .48rem;
            height: .48rem;
            float: left;
            top: .15rem;
            left: .19rem;
          }
        }
      }
      // 活动介绍
      .activity-introduce{
        width: 92%;
        // height: 2.31rem;
        margin: 0 auto;
        margin-top: .15rem;
        background: #ffffff;
        overflow: hidden;
        // 活动标题
        .activity-title{
          font-family: PingFang SC;
          color: #333333;
          font-weight: Bold;
          font-size: 0.36rem;
          line-height: .48rem;
          margin-top: .21rem;
          margin-left: .32rem;
          span{
            display: inline-block;
            width: .48rem;
            height: .24rem;
            font-size: .16rem;
            line-height: .24rem;
            color: #ffffff;
            border-radius:0.04rem;
            text-align: center;
          }
          .person_0{
            background: #FF0000;
            margin-left: .1rem;
          }
          .person_1{
            background: #7FBE39;
            margin-left: .04rem;
          }
          img{
            width: .48rem;
            height: .48rem;
            float: right;
            margin-right: .19rem;
          }
        }
        // 活动详情
        .activity-msg{
          font-family: PingFang SC;
          color: #999999;
          font-size: 0.24rem;
          margin-left: .33rem;
          margin-right: .38rem;
          line-height: .4rem;
          margin-top: .2rem;
          margin-bottom: .31rem;
        }
      }
      // 开通会员卡
      .open-card{
        width: 92%;
        height: .88rem;
        margin: 0 auto;
        line-height: .88rem;
        font-family: PingFang SC;
        font-size: 0.28rem;
        background: #ffffff;
        border-radius: .2rem;
        margin-top: .2rem;
        p{
          &:first-child{
            float: left;
            margin-left: .3rem;
            span{
              color: #EF8201;
            }
          }
          &:last-child{
            float: right;
            margin-right: .6rem;
            color: #EF8201;
          }
        }
      }
      // 图文介绍
      .activity-recommend{
        width: 92%;
        margin: 0 auto;
        background: #ffffff;
        margin-top: .2rem;
        border-radius: .2rem;
        overflow: hidden;
        .title{
          font-size: 0.32rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(51,51,51,1);
          line-height: .32rem;
          margin-top: .29rem;
          margin-left: .19rem;
          margin-bottom: .25rem;
        }
        .content{
          margin-left: .22rem;
          margin-right: .22rem;
          font-size:0.24rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153,153,153,1);
          line-height: 0.3rem;
          padding-bottom: .3rem;
          img{
            width: 100%;
            margin-top: .12rem;
          }
        }
      }
    }
    footer{
      width: 100%;
      height: 1.08rem;
      border-top: .01rem solid rgba(228,228,228,1);
      line-height: 1.08rem;
      p{
        &:first-child{
          font-family: PingFang SC;
          color: #333333;
          float: left;
          margin-left: .31rem;
          span{
            &:first-child{
              font-size: .48rem;
            }
            &:nth-child(2){
              color: #EF8201;
              font-size: 0.5rem;
            }
            &:nth-child(3){
              font-size: 0.36rem;
            }
            &:last-child{
              color: #999999;
            }
          }
        }
        &:last-child{
          float: right;
          width: 2.63rem;
          height: .7rem;
          margin-right: .29rem;
          background:rgba(239,130,1,1);
          border-radius: .35rem;
          margin-top: .2rem;
          line-height: .7rem;
          text-align: center;
          font-family:PingFang SC;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
      }
    }
  }
</style>